// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirm-property-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 80vh;
}
.confirm-property-container .listing-detail {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  font-family: "Proxima Nova", sans-serif;
}
.confirm-property-container .listing-detail .address, .confirm-property-container .listing-detail .listing {
  font-size: 20px;
  font-weight: 700;
  color: var(--secondary-color-3);
  margin: 0;
}
.confirm-property-container .listing-detail .listing {
  color: var(--secondary-color-2);
}
.confirm-property-container .listing-detail .preview {
  width: 650px;
  height: 380px;
  object-fit: cover;
  border-radius: 10px;
}
.confirm-property-container .listing-detail .badge {
  height: 40px;
  width: 150px;
  background: rgba(250, 201, 31, 0.2);
  display: flex;
  border-radius: 5px;
  align-items: center;
  justify-content: center;
}
.confirm-property-container .listing-detail .badge > span {
  color: var(--primary-color-1);
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 700;
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .confirm-property-container {
    min-height: 100vh;
    padding: 0 20px;
  }
  .confirm-property-container .listing-detail {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    font-family: "Proxima Nova", sans-serif;
  }
  .confirm-property-container .listing-detail .address, .confirm-property-container .listing-detail .listing {
    font-size: 16px;
    text-align: center;
  }
  .confirm-property-container .listing-detail .preview {
    width: 100%;
    height: 380px;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/ShowingRequest/modules/ConfirmProperty/confirmProperty.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AADJ;AAEI;EACI,aAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,uCAAA;AAAR;AACQ;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,SAAA;AACZ;AACQ;EAAW,+BAAA;AAEnB;AADQ;EACI,YAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;AAGZ;AADQ;EACI,YAAA;EACA,YAAA;EACA,mCAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;AAGZ;AAFY;EACI,6BAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;AAIhB;;ACzCY;ED4CR;IACI,iBAAA;IACA,eAAA;EACN;EAAM;IACI,aAAA;IACA,WAAA;IACA,sBAAA;IACA,mBAAA;IACA,uCAAA;EAEV;EADU;IACI,eAAA;IACA,kBAAA;EAGd;EADU;IACI,WAAA;IACA,aAAA;EAGd;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\n\n.confirm-property-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 80vh;\n    .listing-detail {\n        display: flex;\n        width: 100%;\n        flex-direction: column;\n        align-items: center;\n        font-family: 'Proxima Nova', sans-serif;\n        .address, .listing {\n            font-size: 20px;\n            font-weight: 700;\n            color: var(--secondary-color-3);\n            margin: 0;\n        }\n        .listing { color: var(--secondary-color-2); }\n        .preview {\n            width: 650px;\n            height: 380px;\n            object-fit: cover;\n            border-radius: 10px;\n        }\n        .badge {\n            height: 40px;\n            width: 150px;\n            background: rgba(#FAC91F, .2);\n            display: flex;\n            border-radius: 5px;\n            align-items: center;\n            justify-content: center;\n            > span {\n                color: var(--primary-color-1);\n                font-family: \"Roboto\", sans-serif;\n                font-size: 14px;\n                font-weight: 700;\n            }\n        }\n    }\n}\n\n@include media(mobile) {\n    .confirm-property-container {\n        min-height: 100vh;\n        padding: 0 20px;\n        .listing-detail {\n            display: flex;\n            width: 100%;\n            flex-direction: column;\n            align-items: center;\n            font-family: 'Proxima Nova', sans-serif;\n            .address, .listing {\n                font-size: 16px;\n                text-align: center;\n            }\n            .preview {\n                width: 100%;\n                height: 380px;\n            }\n        }\n    }\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
